module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<div><%\nif(model.headline){\n%><div class=\"title\"><%= model.headline %></div><%\n}\n%><div class=\"canvasContainer\"><%\n%><canvas class=\"chart\"></canvas><%\n%></div><%\n%><div class=\"legend\"></div><%\n%></div>"
  , __filename = "components/templates/office/dashboard/element/charts/byMonthBars.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div>")
    ; 
if(model.headline){

    ; __line = 3
    ; __append("<div class=\"title\">")
    ; __append(escapeFn( model.headline ))
    ; __append("</div>")
    ; 
}

    ; __line = 5
    ; __append("<div class=\"canvasContainer\">")
    ; 

    ; __line = 6
    ; __append("<canvas class=\"chart\"></canvas>")
    ; 

    ; __line = 7
    ; __append("</div>")
    ; 

    ; __line = 8
    ; __append("<div class=\"legend\"></div>")
    ; 

    ; __line = 9
    ; __append("</div>")
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/office/dashboard/element/charts/byMonthBars.ejs

}